import React from 'react';
import { useTranslate, usePermissions } from 'react-admin';
import { Drawer } from '~/components';
import { EditForm } from '~/components/ra';
import ApplicationRuleForm from './ApplicationRuleForm';
import {} from 'react-admin';

interface Props {
  record: any;
  onClose: () => void;
}

const ApplicationRuleEdit = (props: Props) => {
  const { record, onClose } = props;
  const translate = useTranslate();
  const t = (key: string): string => translate(`resources.applicationRules.fields.${key}`);
  const { permissions } = usePermissions();
  if (!record) return null;
  return (
    <Drawer heading={t('editApplicationRule')} open={!!record} onClose={onClose}>
      <EditForm
        resource='applicationRules'
        closeParent={onClose}
        record={record}
        withDelete
        withDeleteConfirmation
        disabled={!permissions?.includes('externalApplication.update') || record?.deleted}
        deleteButtonProps={{
          variant: 'delete',
          disabled: !permissions?.includes('externalApplication.delete'),
        }}
      >
        <ApplicationRuleForm edit />
      </EditForm>
    </Drawer>
  );
};

export default ApplicationRuleEdit;
